import Rollbar from 'rollbar';
import config from '@/rollbar.config';

const rollbar = new Rollbar(config);

export default {
  install(app) {
    const vueApp = app;
    vueApp.config.errorHandler = (error, vm, info) => {
      rollbar.error(error, { vueComponent: vm, info });
      if (vueApp.config.devtools) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };
    vueApp.provide('rollbar', rollbar);
  },
};
